import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router';

import { setEditingCompany, addCompany, updateCompany, modifyCompany } from 'companies/actions';

import { addGrowlMessage, clearGrowlMessages } from 'messages/actions';

import { verifyToken } from 'auth/actions';

import * as Common from 'common/components';
import * as Companies from 'companies/components';
import { valueFromEvent } from 'lib/util';

class CompanyFormContainer extends Component {
  state = { isValid: false, isSubmitted: false };

  componentWillMount = () => {
    this.props.setEditingCompany();
  };

  handleValueChange = (e) => this.props.modifyCompany(valueFromEvent(e));

  handleSubmit = (e, data) => {
    this.setState({ isSubmitted: true }, () => {
      this.props.clearGrowlMessages();
      if (!this.state.isValid) {
        this.props.addGrowlMessage('error.verify', 'danger', 'common.error');
      }
      return (
        this.state.isValid &&
        this.props
          .saveCompany(this.props.company.id, this.props.company)
          .then(({ value }) => {
            this.props.addGrowlMessage(value.message, 'success', 'common.success');
            this.props.history.push('/');
          })
          .catch(
            (err) =>
              err.code !== 401 && this.props.addGrowlMessage(err.message, 'danger', 'common.error')
          )
      );
    });
  };

  handleValidation = (isValid, message) => {
    this.setState({ isValid });
  };

  render = () => (
    <Common.PageWrapper fluid={true}>
      <Common.PageHeader title={this.props.t('companies.title')} />
      <div className="col-12">
        <Common.Portlet
          title={this.props.t(
            this.props.match.params.id ? 'companies.form_edit_title' : 'companies.form_add_title'
          )}
          icon={this.props.match.params.id ? 'pencil-square-o' : 'plus-circle'}
        >
          <Companies.Form
            values={this.props.company}
            isSubmitted={this.state.isSubmitted}
            isLoading={this.props.company.isLoading}
            handleSubmit={this.handleSubmit}
            handleValidation={this.handleValidation}
            handleValueChange={this.handleValueChange}
          />
        </Common.Portlet>
      </div>
    </Common.PageWrapper>
  );
}

const mapStateToProps = (
  { companies },
  {
    match: {
      params: { id },
    },
  }
) => ({
  company: companies.editing,
});
const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { id },
    },
  }
) => ({
  addGrowlMessage: (text, type, title) => dispatch(addGrowlMessage(text, type, title)),
  clearGrowlMessages: () => dispatch(clearGrowlMessages()),
  saveCompany: (id, data) => dispatch(id ? updateCompany(id, data) : addCompany(data)),
  setEditingCompany: () => dispatch(setEditingCompany(id)),
  modifyCompany: (data) => dispatch(modifyCompany(id, data)),
  verifyToken: () => dispatch(verifyToken()),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(CompanyFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/companies/containers/CompanyFormContainer.js